/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* STICKY ATC */

/* make it sticky */

const stickyAtc = document.querySelector('.sticky-atc');
const productFormAddButton = document.querySelector('.product-form__add-button');

function handleScroll() {
    if (productFormAddButton) {
        const rect = productFormAddButton.getBoundingClientRect();
        if (rect.top < 0) {
            stickyAtc.classList.add('visible');
        } else {
            stickyAtc.classList.remove('visible');
        }
    }
}

window.addEventListener('scroll', handleScroll);

handleScroll();

/* updating prices */

const sourceElement = document.querySelector('.product-form__info-content .price-list');
const targetElement = document.querySelector('.sticky-atc__price');

function updateTargetPrices() {
  const sourceFirstPrice = sourceElement.querySelector('.firstPriceValue');
  const sourceSecondPrice = sourceElement.querySelector('.secondPriceValue');

  const targetFirstPrice = targetElement.querySelector('.firstPriceValue');
  const targetSecondPrice = targetElement.querySelector('.secondPriceValue');

  if (sourceFirstPrice && targetFirstPrice) {
    targetFirstPrice.textContent = sourceFirstPrice.textContent;
  }
  if (sourceSecondPrice && targetSecondPrice) {
    targetSecondPrice.textContent = sourceSecondPrice.textContent;
  }
}

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'childList' || mutation.type === 'subtree') {
      updateTargetPrices();
    }
  });
});

const config = { childList: true, subtree: true };

observer.observe(sourceElement, config);
updateTargetPrices();

/* updating select */

const productFormSelect = document.querySelector('#product-template-4851899302021-quantity');
const stickyAtcSelect = document.querySelector('.sticky-atc__quantity select');

function updateOtherSelect(changedSelect, otherSelect) {
  otherSelect.value = changedSelect.value;
}

if (productFormSelect && stickyAtcSelect) {
  productFormSelect.addEventListener('change', function() {
    updateOtherSelect(this, stickyAtcSelect);
  });

  stickyAtcSelect.addEventListener('change', function() {
    updateOtherSelect(this, productFormSelect);
  });
}

/* atc action */

document.addEventListener('DOMContentLoaded', function() {
    const stickyButton = document.querySelector('.sticky-atc__button');
    
    stickyButton.addEventListener('click', function(event) {
        const productForm = document.querySelector('form.product-form');
        
        if (productForm) {
            const formSubmitButton = productForm.querySelector('button[type="submit"]');
            
            if (formSubmitButton) {
                formSubmitButton.click();
            } else {
                console.error('Add to basket button not found within the product form');
            }
        } else {
            console.error('Product form not found');
        }
    });
});